import React from 'react';
import { useHistory } from 'react-router-dom';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { SiteConfigManager } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';
import { Icon } from '@atlas/ui';

const { CASINO } = COMPONENT_TYPES;

const SubHeader = ({ isStaticPage, pageName = '' }) => {
  const { goBack, push: historyPush } = useHistory();
  const casinoPath = SiteConfigManager.getComponentPath(CASINO, 'casino');

  const handleClose = () => {
    historyPush(casinoPath);
  };

  const wrpCls = cx('sub-header-terminal', {
    'sub-header-terminal-static': isStaticPage,
  });

  return (
    <div className={wrpCls}>
      {isStaticPage && <Icon name="back" onClick={goBack} />}
      <span className="page-name">{pageName}</span>
      {!isStaticPage && (
        <div
          className="close-button"
          onClick={handleClose}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleClose();
            }
          }}
          role="button"
          tabIndex={0}
        >
          <Icon name="close" />
        </div>
      )}
    </div>
  );
};

SubHeader.propTypes = {
  isStaticPage: PropTypes.bool,
  pageName: PropTypes.string,
};

export default SubHeader;
